import React from 'react'

// https://github.com/react-bootstrap/react-bootstrap/blob/master/src/FormGroup.tsx
export const FormGroup = ({ children, controlId }) => {
  return (
    <div className="field">{children}</div>
  )
}